import { DocumentsIcon } from "components/ui/icons/menuDrawer/DocumentsIcon"
import { FoundItemsIcon } from "components/ui/icons/menuDrawer/FoundItemsIcon"
import { ConfigurationsIcon } from "components/ui/icons/menuDrawer/ConfigurationsIcon"
import { VersionsIcon } from "components/ui/icons/menuDrawer/VersionsIcon"
import { QuotationsIcon } from "components/ui/icons/menuDrawer/QuotationsIcon"
import { CustomModelNumbersIcon } from "components/ui/icons/modelNumber/CustomModelNumbersIcon"
import { canAccessQuotations } from "helpers/drawingAccess.helper"
import type { TDrawingOwner } from "helpers/drawingAccess.helper"
import type { MenuProps } from "antd"

const lockQuotationFeature = import.meta.env.VITE_LOCK_QUOTATION_FEATURE !== "false"

export const MenuItems = (
	finalDrawingStatus: string,
	userRole: string,
	drawingOwner: TDrawingOwner,
): MenuProps["items"] => {
	const fileStatusIsNotProcessed = finalDrawingStatus !== "processed"
	const quotationsUnavailable = !canAccessQuotations(userRole, drawingOwner)

	return [
		{
			key: "processing",
			label: "PROCESSING",
			type: "group",
			children: [
				{ key: "documents", label: "Documents", disabled: false, icon: <DocumentsIcon /> },
				{
					key: "found-items",
					label: "Found items",
					icon: <FoundItemsIcon />,
					children: [
						{
							key: "specification-keywords",
							label: "Specification keywords",
							disabled: fileStatusIsNotProcessed,
						},
						{
							key: "drawing-keywords",
							label: "Drawing keywords",
							disabled: fileStatusIsNotProcessed,
						},
						{ key: "objects", label: "Objects", disabled: fileStatusIsNotProcessed },
					],
				},
				{
					key: "configurations",
					label: "Configurations",
					icon: <ConfigurationsIcon />,
					children: [
						{
							key: "configuration-specification-keywords",
							label: "Specification keywords",
							disabled: fileStatusIsNotProcessed,
						},
						{
							key: "configuration-drawing-keywords",
							label: "Drawing keywords",
							disabled: fileStatusIsNotProcessed,
						},
						{
							key: "specification-objects",
							label: "Objects",
							disabled: fileStatusIsNotProcessed,
						},
					],
				},
				{
					key: "versions",
					label: "Versions",
					icon: <VersionsIcon />,
					disabled: finalDrawingStatus === "processed" || finalDrawingStatus === "failed" ? false : true,
				},
			],
		},
		{
			key: "quotations",
			label: "QUOTATIONS",
			type: "group",
			children: [
				{
					key: "quotations",
					label: "All quotations",
					icon: <QuotationsIcon />,
					disabled: quotationsUnavailable || fileStatusIsNotProcessed || lockQuotationFeature,
				},
				{
					key: "custom-model-numbers",
					label: "Custom model numbers",
					icon: <CustomModelNumbersIcon />,
					disabled: quotationsUnavailable || fileStatusIsNotProcessed || lockQuotationFeature,
				},
			],
		},
	]
}
